import { CSSResultGroup, html, LitElement } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { classMap } from 'lit/directives/class-map.js'
import { style } from './badge.style.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'


export const badgeVariants = ['default', 'error', 'info', 'success', 'warning', 'new', 'our-choice', 'bestseller', 'sale', 'premium'] as const
export type badgeVariantTypes = typeof badgeVariants

export const badgeCompositions = ['solid', 'bordered', 'simple', 'floating'] as const
export type badgeCompositionTypes = typeof badgeCompositions

export const badgeSizes = ['default', 'small'] as const
export type badgeSizeTypes = typeof badgeSizes


@customElement('cse-badge')
export class CSEBadge extends LitElement {
  static override styles: CSSResultGroup = [hostStyle, style]

  @property({ type: String })
  variant: badgeVariantTypes[number] = 'default'

  @property({ type: String })
  composition: badgeCompositionTypes[number] = 'solid'

  @property({ type: String })
  size: badgeSizeTypes[number] = 'default' 

  override render() {
    const classes = classMap({
      'cse-badge': true,
      [`variant-${this.variant}`]: true,
      [`composition-${this.composition}`]: true,
      [`size-${this.size}`]: true,
    })

    return html`
      <div class="${classes}">
        <slot name="prefix"></slot>
        <slot></slot>
      </div>
    `
  }
}


declare global {
  interface HTMLElementTagNameMap {
    'cse-badge': CSEBadge
  }
}
